<svelte:head>
  <title>Sim 3D - Login</title>
  <link rel="stylesheet" href="styles/pages/login.css"/>
</svelte:head>
<script>
  // ts-check
  import { login, userStore } from '../services/session'
  import { _, langs, locale } from '../services/i18n'
  import Switch from '../ui/Switch.svelte'
  import RegisterForm from './RegisterForm.svelte'
  import { alert } from '../services/stores/alert'

  import { slide } from 'svelte/transition'
  import { replace } from 'svelte-spa-router'

  let username, pass, rememberUser = true

  userStore.subscribe(user => {
    user.isAuth.then(isAuthenticated => {
      if(isAuthenticated)
        replace('/')
    })
  })

  const loginUser = async () => {
    let response = await login({user: username, pass, rememberUser})
    if(response.status === 404)
      alert.newAlert({
        message: $_('login_error404'),
        type: 'error'
      })
  }

  let passwordInput, butonEye
  const visibleEye = e => {
    e.target.classList.add("input-password");
    butonEye.classList.remove("d-none");
  }

  const togglePass = e => {
    const button = e.target
    if(passwordInput.type==="password"){
      passwordInput.type="text";
      button.setAttribute("aria-label","Hide password.")
    } else {
      passwordInput.type="password";
      button.setAttribute("aria-label","Show password as plain text. "+"Warning: this will display your password on the screen.")
    }
  }

  let modalRegister = false
  let langOption = false
  const closePopups = () => {
    modalRegister = false
    langOption = false
  }
  const selectLang = lang => {
    if($locale !== lang.code)
      lang.action()
    langOption = false
  }

</script>
<svelte:body on:click={closePopups}/>
<section id="login">
  <div class="background">
    <!-- <div class="span-fondo">
      <span>Esto no<br/>es solo<br/>un simulador</span>
    </div> -->
    <img class="sofa" src="icons/default_logo_2.png" alt=""/>
    <!-- <div class="linterna"></div> -->
    <footer>
      <ul class="rrss">
        <li>
          <a href="https://www.facebook.com/sim3Dsimulator" target="_blank" rel="noreferrer">
            <img src="icons/facebook.svg" alt=""/>
          </a>
        </li>
        <li>
          <a href="https://www.youtube.com/watch?v=JgjQ_gIuUM8&list=PLy2fmlyM8FcXN8eknhzLJ2MtoFysQ5Umj" target="_blank" rel="noreferrer">
            <img src="icons/youtube.svg" alt=""/>
          </a>
        </li>
      </ul>
      <span>Powered by: <strong class="gsim"><a href="https://gruposim.eu">Grupo SIM</a></strong></span>  
    </footer>
  </div>
  <nav class="nav-demo-xl">
    <ul>
      <li class="logo">
        <a href="https://sim3d.es" target="_blank" id="logo-pc" rel="noreferrer">
          <img src="icons/default_logo_3.png" alt=""/>
        </a>
        <div class="rrss-mobile">      
           <a href="https://www.facebook.com/sim3Dsimulator" target="_blank" rel="noreferrer">
             <img src="icons/facebook.svg" alt=""/>
           </a>
            <a href="https://www.youtube.com/watch?v=JgjQ_gIuUM8&list=PLy2fmlyM8FcXN8eknhzLJ2MtoFysQ5Umj" target="_blank" rel="noreferrer">
              <img src="icons/youtube.svg" alt=""/>
            </a>
          </div>
      </li>
      <li><span>{$_('login_notUserQuestion')}</span></li>
      <li style="position: relative;" on:click|stopPropagation on:keypress|stopPropagation>
        <button class="btn-3d" on:click={() => modalRegister = !modalRegister}>
        {$_('login_register')}
        </button>
        {#if modalRegister}
        <div class="register-modal" transition:slide>
          <RegisterForm on:close={() => modalRegister = false} />
        </div>
        {/if}
      </li>
      <li><a href="/sim3d.html"><button type="secondary" class="btn-3d second">{$_('login_demoAccess')}</button></a></li>  
    </ul> 
  </nav>
  <div id="lang-selector" on:click|stopPropagation on:keypress|stopPropagation>
    <button type="button" id="lang-selector-button" aria-label={$_('nav_user_language')} on:click={() => langOption = !langOption}>
      <img src="/icons/language-sim3d.svg" alt=""/>
      <span>{($locale || 'es').split('-')[0]}</span>
    </button>
    {#if langOption}
      <ul class="lang-list" transition:slide>
        {#each langs as lang}
          <li class:active-lang={$locale === lang.code} on:keydown={() => {}} on:click={() => selectLang(lang)}>
            <span>{lang.name}</span>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
  <form on:submit|preventDefault={loginUser} class="loginCard">
    <a href="https://sim3d.es" target="_blank" id="logo-mobile" rel="noreferrer">
      <img src="icons/sim3d-logo-blanco.svg" alt=""/>
    </a>
    <h1>{$_('login_welcome')}</h1>
    <h2>{$_('login_isGreat')}</h2>
     <div id="centered-mobile">
       <label for="user">{$_('login_username')}</label>
       <input
           placeholder={$_('login_userPlaceholder')}
           id="user"
           outlined
           type="text"
           color="blue"
           autocapitalize="none"
           autocomplete="username"
           autocorrect="off"
           spellcheck='false'
           bind:value={username}
           required/>
       <label for="password">{$_('login_password')}</label>
       <div class="input-group">
         <input
            id="password"
            class="password form-control rounded-right"
            outlined
            type="password"
            placeholder={$_('login_passPlaceholder')}
            color="blue"
            autocapitalize="none"
            autocomplete="password"
            autocorrect="off"
            spellcheck='false'
            on:focus={visibleEye}
            bind:value={pass}
            bind:this={passwordInput}
            required/>
            <button id="toggle-password" type="button" class="d-none" on:click={togglePass} bind:this={butonEye}></button>
      </div>
    </div>
    <Switch label={$_('login_checkRemember')} klass="checkbox" lined="start" bind:checked={rememberUser}/>
    <button 
        id='login-button' 
        class='btn-3d' 
        style='margin: 0;  width: 200px;' 
        type='submit'>
      {$_('login_access')}
    </button>
  </form>

<ul id="login-mobile-buttons">
  <li style="position: relative;" on:click|stopPropagation on:keypress|stopPropagation>
    <button class="btn-3d" on:click={() => modalRegister = !modalRegister}    id="register">
    {$_('login_register')}
    </button>
    {#if modalRegister}
    <div class="register-modal-t">
    <div class="register-modal" transition:slide>
      <RegisterForm mobile on:close={() => modalRegister = false} />
    </div>
  </div>
    {/if}
  </li>
  <li>
    <a href="/sim3d.html" id="demo-mobile-btn">
      <button type="secondary" class="btn-3d second mobile-btn" id="demo-mobile">
        {$_('login_demoAccessMobile')}
      </button>
    </a>
  </li>
</ul>
</section>